<template>
  <div id="app">
    <router-view @login="signin"></router-view>
  </div>
</template>

<script>
import * as util from '@/assets/js/util.js';
import {allRouter} from '@/router/allRouter'
import {resetRouter} from '@/router/router'

export default {
  name: 'app',
  data() {
    return {
      routeData: [],
    }
  },
  methods: {
    data2treeDG(datas, dataArray) {
      for (let j = 0; j < dataArray.length; j++) {
        let dataArrayIndex = dataArray[j];
        let childrenArray = [];
        let Id = dataArrayIndex.id;
        let pName = dataArrayIndex.name;
        let level = dataArrayIndex.level + 1;
        for (let i = 0; i < datas.length; i++) {
          let data = datas[i];
          let pid = data.pid;
          if (pid == Id) {//判断是否为儿子节点

            let objTemp = {
              ...data,
              pName: pName,
              level: level,
              path: data.menuUrl,
              pType: dataArrayIndex.menuType
            }

            childrenArray.push(objTemp);
          }
        }

        dataArrayIndex.children = childrenArray;
        if (childrenArray.length > 0) {//有儿子节点则递归
          this.data2treeDG(datas, childrenArray,)
        }
      }
      return dataArray;
    },
    signin: function (callback) {
      let localUser = util.session('token');
      if (!localUser || !localUser.token) {
        return this.$router.push({path: '/login'});
      }
      if (!this.$store.state.token) {
        this.$store.dispatch('setToken', util.session('token').token);
      }
      //this.$store.dispatch('setUserInfo', util.session('userInfo').userInfo);
      //   let businessType=util.session('businessType');
      //   if (!this.$store.state.businessType) {
      //       this.$store.dispatch('setBusinessType', businessType);
      //   }
      //   if (!this.$store.state.projectUrl) {
      //       this.$store.dispatch('setProjectUrl', util.session('projectUrl'));
      //   }
      //   if (!this.$store.state.project) {
      //       this.$store.dispatch('setProject', util.session('project'));
      //   }
      // if (!this.$store.state.projectWhiteEntity) {
      //     this.$store.dispatch('setProjectWhiteEntity', util.session('projectWhiteEntity'));
      // }
      // if(businessType=='2'||businessType=='8'||businessType=='10') {
      //     // if (!this.$store.state.userProjectRelation) {
      //     //     this.$store.dispatch('setUserProjectRelation', util.session('userProjectRelation').userProjectRelation);
      //     // }
      //     // if (!this.$store.state.privateKey) {
      //     //     this.$store.dispatch('setPrivateKey', util.session('privateKey'));
      //     // }
      //     // if (!this.$store.state.whiteYearMonth) {
      //     //     this.$store.dispatch('setWhiteYearMonth', util.session('whiteYearMonth').whiteYearMonth);
      //     // }
      //     // if (!this.$store.state.whiteYearMonthName) {
      //     //     this.$store.dispatch('setWhiteYearMonthName', util.session('whiteYearMonthName').whiteYearMonthName);
      //     // }
      //     // if (!this.$store.state.whiteListIsOpen) {
      //     //     this.$store.dispatch('setWhiteListIsOpen', util.session('whiteListIsOpen').whiteListIsOpen);
      //     // }
      //     // if (!this.$store.state.supplementaryOpen) {
      //     //     this.$store.dispatch('setSupplementaryOpen', util.session('supplementaryOpen').supplementaryOpen);
      //     // }
      //     // if (!this.$store.state.currentPhase) {
      //     //     this.$store.dispatch('setCurrentPhase', util.session('currentPhase').currentPhase);
      //     // }
      //     // if (!this.$store.state.isOpenEditHistory) {
      //     //     this.$store.dispatch('setIsOpenEditHistory', util.session('isOpenEditHistory').isOpenEditHistory);
      //     // }
      //     // if (!this.$store.state.supplementBatch) {
      //     //     this.$store.dispatch('setSupplementBatch', util.session('supplementBatch').supplementBatch);
      //     // }
      //   // if (!this.$store.state.invoiceStart) {
      //   //   this.$store.dispatch('setInvoiceStart', util.session('invoiceStart').invoiceStart);
      //   // }
      //   // if (!this.$store.state.invoiceEnd) {
      //   //   this.$store.dispatch('setInvoiceEnd', util.session('invoiceEnd').invoiceEnd);
      //   // }
      //   // if (!this.$store.state.invoiceRestrictionStart) {
      //   //   this.$store.dispatch('setInvoiceRestrictionStart', util.session('invoiceRestrictionStart').invoiceRestrictionStart);
      //   // }
      //   // if (!this.$store.state.invoiceRestrictionEnd) {
      //   //   this.$store.dispatch('setInvoiceRestrictionEnd', util.session('invoiceRestrictionEnd').invoiceRestrictionEnd);
      //   // }
      //   //   if (!this.$store.state.supplementBatchEntity) {
      //   //       this.$store.dispatch('setSupplementBatchEntity', util.session('supplementBatchEntity').supplementBatchEntity);
      //   //   }
      //     if (!this.$store.state.commonBatchEntity) {
      //         this.$store.dispatch('setCommonBatchEntity', util.session('commonBatchEntity').commonBatchEntity);
      //     }
      // }
      // if(businessType=='2'||businessType=='4'||businessType=='8'){
      //     if (!this.$store.state.auditOpen) {
      //         this.$store.dispatch('setAuditOpen', util.session('auditOpen').auditOpen);
      //     }
      // }

      // if (!this.$store.state.userInfo) {
      //     this.$store.dispatch('setUserInfo', util.session('userInfo').userInfo);
      // }
      if (!this.$store.state.menuList|| this.$store.state.menuList.length == 0) {
        this.$store.dispatch('setMenuList', util.session('menuList').menuList);
      }
      if (!this.$store.state.menuList || this.$store.state.menuList.length == 0) {
        this.$message.error('您当前没有登录权限，请联系管理员')
        return this.$router.push({path: '/login'});
      }
      let menuArray = [];
      let menuList=this.$store.state.menuList;
      this.routeData = this.getRoutes(menuList);
      this.setRoute();
      menuList.forEach(function (item) {
        item.children = []
        let pid = item.pid;
        if (pid == 0) {
          let objTemp = {
            ...item,
            pName: '没有上级',
            level: 1
          }
          menuArray.push(objTemp);
        }
      })
      let treeData = this.data2treeDG(menuList, menuArray);
      if (treeData[0] && treeData[0].children) {
        let menuArray = this.sortArray(treeData[0].children);
        this.$store.dispatch('setMenuList', menuArray);
      }
      typeof callback === 'function' && callback();
    },
    sortArray(array) {
      array.sort((a, b) => {
        return a.menuSort - b.menuSort
      })
      array.forEach((item) => {
        if (item.children) {
          this.sortArray(item.children)
        }
      })

      return array
    },
    extentRoute(routeArr) {
      // let reg = this.regRoute;
      // let routeData = this.routeData;
      routeArr.forEach((item) => {
        item.beforeEnter = (to, from, next) => {
          let localUser = util.session('token');
          if (!localUser || !localUser.token) {
            return this.$router.push({path: '/login'});
          }
          next()
          // console.log(routeData)
          // console.log(to.path)
          // if (reg(to.path, routeData)) {
          //   next()
          // } else {
          //   next('/no')
          // }
        }
        if (item.children) {
          this.extentRoute(item.children);
        }
      })

      return routeArr
    },
    // regRoute(path, routeData) {
    //   let reg = false;
    //   for (let i = 0; i < routeData.length; i++) {
    //     let item = routeData[i];
    //     //判断是否相等 如果相等直接返回true
    //     if (item.menuUrl == path) {
    //       reg = true;
    //       break
    //     }
    //     //如果不相等 有两种情况  一种是路由传参  一种是不传参
    //       if (item.menuUrl){
    //           if (item.menuUrl.indexOf(':') != -1) {
    //               let arr = item.menuUrl.split('/:');
    //               let url = arr[0];
    //               let index = path.indexOf(url);
    //               if (index != -1) {
    //                   let paramsArr = path.slice(url.length + 1).split('/');
    //                   if (paramsArr.length == (arr.length - 1)) {
    //                       reg = true
    //                       break
    //                   }
    //               }
    //           }
    //       }
    //       // if(!reg){//判断路由
    //       //     let author = item.author;
    //       //     let authorArr=author.split(',')
    //       //     for (let j = 0; j < authorArr.length; j++){
    //       //         console.log(path+","+authorArr[j])
    //       //         if (authorArr[j].indexOf(path)!=-1){
    //       //             reg = true
    //       //             break
    //       //         }
    //       //     }
    //       // }
    //
    //   }
    //   return reg
    // },
    getRoutes(routeData) {
      return routeData.filter((item) => {
        return item.menuType == '路由'
      })
    },
    setRoute() {
      let route;
      // let userProjectRelation = this.$store.state.userProjectRelation;
      // let userInfo= this.$store.state.userProjectRelation.user;
      // if (userProjectRelation.status=='2'||userProjectRelation.interType=='API'){
      //     route= this.extentRoute(allRouterNotApprove); //审批未通过只展示信息中心菜单
      // }else if (userProjectRelation.status=='1'&&userInfo.businessType!='3'&&userInfo.businessType!='4'){
      //     route= this.extentRoute(allRouter);
      // }else if (userInfo.businessType=='3'){
      //     route= this.extentRoute(allRouterForVerification); //核销方
      // }else if (userInfo.businessType=='4'){
      //     route= this.extentRoute(allRouterForDirect); //主办方
      // }
      route= this.extentRoute(allRouter);

      let routes = [
        {
          path: '/',
          name: 'base',
          redirect: '/coupon/centerInfo/info'
        },
        {
          path: '/layout',
          name: 'home',
          component: () => import('@/components/layout/index.vue'),
          children: [
            ...route,
            {
              path: '/no',
              name: '权限不足',
              component: () => import('@/views/error/errNo.vue')
            },
            {
              path: '/404',
              name: '找不到页面1',
              component: () => import('@/views/error/err404.vue')
            }
          ]
        }, {
          path: '/401',
          name: '无权访问',
          component: () => import('@/views/error/err401.vue')
        },
        {
          path: '/404',
          name: '找不到页面',
          component: () => import('@/views/error/err404.vue')
        }]
      resetRouter();
      routes.forEach(route=>{
        this.$router.addRoute(route);
      })
      // this.$router.addRoutes(routes);
    },
  },
  mounted() {
    document.title = process.env.VUE_APP_NAME;
    this.signin();
  }
}
</script>

<style>
* {
  box-sizing: border-box
}

html, body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
}

.edui-border_box {
  border: 1px solid #dcdfe6;
  text-align: left;
  line-height: 20px;
}

.el-form-item.is-error .edui-border_box {
  border-color: #f56c6c;
}

.el-form-item.is-success .edui-border_box {
  border-color: #67c23a;
}

.el-select-dropdown__item {
  /*font-size: 12px!important;*/
  /*font-weight: normal!important;*/
}
</style>
